var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "dialog-drag", rawName: "v-dialog-drag" }],
      attrs: {
        visible: _vm.innerVisible,
        title:
          "" +
          (_vm.isFcl ? _vm.$t("Price.FCL") : _vm.$t("Price.LCL")) +
          _vm.$t("Message.FreightRateDetails"),
        width: "1000px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        top: "5vh",
        "custom-class": "price-dialog"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _vm.innerVisible
        ? [
            _c("div", { staticClass: "price-dialog-header" }, [
              _c("div", { staticClass: "left" }, [
                _c("h2", { staticStyle: { color: "#ffce6b" } }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("Pricing.PriceType")) + "：")
                  ]),
                  _c("span", [_vm._v(_vm._s(_vm.freightType))])
                ]),
                _c("h2", [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.priceAddon && _vm.isFcl
                          ? _vm.getPortName(_vm.priceAddon.pol_a)
                          : _vm.getPortName(_vm.price.pol)
                      )
                    )
                  ]),
                  _c("span", { staticStyle: { margin: "0 10px" } }, [
                    _vm._v("————")
                  ]),
                  _c("span", [_vm._v(_vm._s(_vm.getPortName(_vm.price.pod)))])
                ]),
                _c("h3", [
                  _vm._v(" " + _vm._s(_vm.$t("Price.FreightNumber")) + " "),
                  _c("span", [_vm._v(_vm._s(_vm.price.priceNo))])
                ]),
                _c("h3", [
                  _vm._v(" " + _vm._s(_vm.$t("Price.CabinStatus")) + " "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.getPriceStateLabel(_vm.price.priceState)))
                  ])
                ])
              ]),
              _c(
                "div",
                {
                  staticClass: "right",
                  class: [
                    _vm.price.trend === -1 ? "green" : "",
                    _vm.price.trend === 1 ? "red" : ""
                  ]
                },
                [
                  _vm.isFcl
                    ? _c(
                        "div",
                        { staticStyle: { flex: "1", "margin-right": "10px" } },
                        [
                          _c(
                            "el-row",
                            { attrs: { type: "flex", justify: "end" } },
                            [
                              _vm.hbRate.visible20
                                ? _c(
                                    "el-col",
                                    { attrs: { span: 5, offset: 4 } },
                                    [_vm._v(_vm._s("20'" + _vm.price.eqType))]
                                  )
                                : _vm._e(),
                              _vm.hbRate.visible40
                                ? _c("el-col", { attrs: { span: 5 } }, [
                                    _vm._v(_vm._s("40'" + _vm.price.eqType))
                                  ])
                                : _vm._e(),
                              _vm.hbRate.visibleHC
                                ? _c("el-col", { attrs: { span: 5 } }, [
                                    _vm._v("40'HC")
                                  ])
                                : _vm._e(),
                              _vm.hbRate.visible45
                                ? _c("el-col", { attrs: { span: 5 } }, [
                                    _vm._v(_vm._s("45'" + _vm.price.eqType))
                                  ])
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { attrs: { type: "flex", justify: "end" } },
                            [
                              _c("el-col", { attrs: { span: 4 } }, [
                                _vm._v("OF")
                              ]),
                              _vm.hbRate.visible20
                                ? _c("el-col", { attrs: { span: 5 } }, [
                                    _vm._v(_vm._s(_vm.hbRate.lblOF20))
                                  ])
                                : _vm._e(),
                              _vm.hbRate.visible40
                                ? _c("el-col", { attrs: { span: 5 } }, [
                                    _vm._v(_vm._s(_vm.hbRate.lblOF40))
                                  ])
                                : _vm._e(),
                              _vm.hbRate.visibleHC
                                ? _c("el-col", { attrs: { span: 5 } }, [
                                    _vm._v(_vm._s(_vm.hbRate.lblOFHC))
                                  ])
                                : _vm._e(),
                              _vm.hbRate.visible45
                                ? _c("el-col", { attrs: { span: 5 } }, [
                                    _vm._v(_vm._s(_vm.hbRate.lblOF45))
                                  ])
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { attrs: { type: "flex", justify: "end" } },
                            [
                              _c("el-col", { attrs: { span: 4 } }, [
                                _vm._v("ALL IN")
                              ]),
                              _vm.hbRate.visible20
                                ? _c("el-col", { attrs: { span: 5 } }, [
                                    _vm._v(_vm._s(_vm.hbRate.lblALLIN20))
                                  ])
                                : _vm._e(),
                              _vm.hbRate.visible40
                                ? _c("el-col", { attrs: { span: 5 } }, [
                                    _vm._v(_vm._s(_vm.hbRate.lblALLIN40))
                                  ])
                                : _vm._e(),
                              _vm.hbRate.visibleHC
                                ? _c("el-col", { attrs: { span: 5 } }, [
                                    _vm._v(_vm._s(_vm.hbRate.lblALLINHC))
                                  ])
                                : _vm._e(),
                              _vm.hbRate.visible45
                                ? _c("el-col", { attrs: { span: 5 } }, [
                                    _vm._v(_vm._s(_vm.hbRate.lblALLIN45))
                                  ])
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "p",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.price.priceState === 4 ||
                                    _vm.price.priceState === 5,
                                  expression:
                                    "price.priceState === 4 || price.priceState === 5"
                                }
                              ],
                              staticClass: "red"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("Price.OurDumpingOfContainersOK"))
                              )
                            ]
                          ),
                          _c("p", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "Price.NoteAdditionalChargesWithBackground"
                                )
                              )
                            )
                          ])
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticStyle: { flex: "1", "margin-right": "10px" } },
                        [
                          _c(
                            "el-row",
                            { attrs: { type: "flex", justify: "end" } },
                            [
                              _c("el-col", { attrs: { span: 5, offset: 4 } }, [
                                _vm._v("TON")
                              ]),
                              _c("el-col", { attrs: { span: 5 } }, [
                                _vm._v("CBM")
                              ])
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { attrs: { type: "flex", justify: "end" } },
                            [
                              _c("el-col", { attrs: { span: 5 } }, [
                                _vm._v(_vm._s(_vm.$t("Pricing.ColoaderPrice")))
                              ]),
                              _c("el-col", { attrs: { span: 5 } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.getNumberLabel(_vm.price.oneWeightPrice)
                                  )
                                )
                              ]),
                              _c("el-col", { attrs: { span: 5 } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.getNumberLabel(_vm.price.oneVolumePrice)
                                  )
                                )
                              ])
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { attrs: { type: "flex", justify: "end" } },
                            [
                              _c("el-col", { attrs: { span: 5 } }, [
                                _vm._v(_vm._s(_vm.$t("Pricing.CustomerPrice")))
                              ]),
                              _c("el-col", { attrs: { span: 5 } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.getNumberLabel(_vm.price.twoWeightPrice)
                                  )
                                )
                              ]),
                              _c("el-col", { attrs: { span: 5 } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.getNumberLabel(_vm.price.twoVolumePrice)
                                  )
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                  _vm.$checkPermission(["module_RemoteBooking"]) &&
                  _vm.level > 0
                    ? _c(
                        "el-button",
                        {
                          staticStyle: {
                            width: "80px",
                            "margin-bottom": "10px"
                          },
                          attrs: { no: "onRemoteBooking", type: "primary" },
                          on: { click: _vm.onRemoteBooking }
                        },
                        [_vm._v(_vm._s(_vm.$t("Price.Booking")))]
                      )
                    : _vm._e()
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "price-dialog-content" },
              [
                _c(
                  "div",
                  { staticClass: "description" },
                  [
                    [
                      _vm.isFcl
                        ? _c(
                            "div",
                            [
                              _c(
                                "el-row",
                                [
                                  _c("el-col", { attrs: { span: 1 } }, [
                                    _vm._v(_vm._s(_vm.$t("Pricing.Carrier")))
                                  ]),
                                  _c(
                                    "el-col",
                                    { staticClass: "blue", attrs: { span: 4 } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getCarrierName(
                                            _vm.price.carrierScacCode,
                                            _vm.price.carrier
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _c("el-col", { attrs: { span: 1 } }, [
                                    _vm._v(_vm._s(_vm.$t("SeaExport.Vessel")))
                                  ]),
                                  _c(
                                    "el-col",
                                    { staticClass: "blue", attrs: { span: 3 } },
                                    [_vm._v(_vm._s(_vm.price.vessel))]
                                  ),
                                  _c("el-col", { attrs: { span: 1 } }, [
                                    _vm._v(_vm._s(_vm.$t("SeaExport.Voyage")))
                                  ]),
                                  _c(
                                    "el-col",
                                    { staticClass: "blue", attrs: { span: 3 } },
                                    [_vm._v(_vm._s(_vm.price.voyageFlight))]
                                  ),
                                  _c("el-col", { attrs: { span: 1 } }, [
                                    _vm._v("ETD")
                                  ]),
                                  _c(
                                    "el-col",
                                    {
                                      staticClass: "blue",
                                      staticStyle: {
                                        "white-space": "nowrap",
                                        overflow: "hidden",
                                        "text-overflow": "ellipsis"
                                      },
                                      attrs: {
                                        span: 4,
                                        title: _vm.getEtdName()
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.getEtdName()))]
                                  ),
                                  _c("el-col", { attrs: { span: 1 } }, [
                                    _vm._v("ETA")
                                  ]),
                                  _c(
                                    "el-col",
                                    {
                                      staticClass: "blue",
                                      staticStyle: {
                                        "white-space": "nowrap",
                                        overflow: "hidden",
                                        "text-overflow": "ellipsis"
                                      },
                                      attrs: {
                                        span: 3,
                                        title: _vm.getEtaName()
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.getEtaName()))]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                [
                                  _c("el-col", { attrs: { span: 2 } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("Pricing.BookingAgent"))
                                    )
                                  ]),
                                  _c(
                                    "el-col",
                                    {
                                      staticClass: "blue",
                                      attrs: { span: 21 }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getBookingAgentName(
                                            _vm.price.bookingAgent
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              _c(
                                "el-row",
                                [
                                  _c("el-col", { attrs: { span: 2 } }, [
                                    _vm._v(_vm._s(_vm.$t("Pricing.Carrier")))
                                  ]),
                                  _c(
                                    "el-col",
                                    {
                                      staticClass: "blue",
                                      attrs: { span: 21 }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getCarrierName(
                                            _vm.price.carrierScacCode,
                                            _vm.price.carrier
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                [
                                  _c("el-col", { attrs: { span: 2 } }, [
                                    _vm._v(_vm._s(_vm.$t("Pricing.Source")))
                                  ]),
                                  _c(
                                    "el-col",
                                    {
                                      staticClass: "blue",
                                      attrs: { span: 21 }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getBookingAgentName(
                                            _vm.price.bookingAgent
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-row",
                                [
                                  _c("el-col", { attrs: { span: 2 } }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("Pricing.ShareCarriers"))
                                    )
                                  ]),
                                  _c(
                                    "el-col",
                                    {
                                      staticClass: "blue",
                                      attrs: { span: 21 }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getShareCarrierLabel(
                                            _vm.price.ShareCarriers
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                    ],
                    [
                      _vm.isFcl
                        ? _c("div", [
                            _c("div", { staticClass: "info" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("Pricing.TradeLane")))
                              ]),
                              _c("span", { staticClass: "blue" }, [
                                _vm._v(_vm._s(_vm.getRegionName(_vm.price.pod)))
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("Pricing.Days")))
                              ]),
                              _c("span", { staticClass: "blue" }, [
                                _vm._v(_vm._s(_vm.price.days))
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("Pricing.DepartureDay")))
                              ]),
                              _c("span", { staticClass: "blue" }, [
                                _vm._v(_vm._s(_vm.isFrequency))
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("Pricing.BasicPort")))
                              ]),
                              _c("span", { staticClass: "blue" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.price.hasOwnProperty("PriceFclAddonEx")
                                      ? _vm.getPortName(_vm.price.pol)
                                      : null
                                  )
                                )
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("Pricing.Via")))
                              ]),
                              _c("span", { staticClass: "blue" }, [
                                _vm._v(_vm._s(_vm.getPortName(_vm.price.via)))
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("Pricing.Dock")))
                              ]),
                              _c("span", { staticClass: "blue" }, [
                                _vm._v(_vm._s(_vm.price.dock))
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("Pricing.VAT")))
                              ]),
                              _c("span", { staticClass: "blue" }, [
                                _vm._v(
                                  _vm._s(
                                    (_vm.level === 0
                                      ? _vm.price.costVat
                                      : _vm.price.sellVat) + "%"
                                  )
                                )
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("Pricing.BeginDate")))
                              ]),
                              _c("span", { staticClass: "blue" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm
                                      .$moment(_vm.price.beginDate)
                                      .format("YYYY-MM-DD") +
                                      " - " +
                                      _vm
                                        .$moment(_vm.price.endDate)
                                        .format("YYYY-MM-DD")
                                  )
                                )
                              ])
                            ]),
                            _c("div", { staticClass: "info" }, [
                              _c("span", { staticStyle: { float: "left" } }, [
                                _vm._v(_vm._s(_vm.$t("Pricing.Remarks")))
                              ]),
                              _c("textarea", {
                                staticClass: "blueRemark",
                                style:
                                  "width:90%;overflow-y: visible;" +
                                  (_vm.price.remarks
                                    ? "border-width: 1px;border-color: #ccc;"
                                    : "border: none;resize: none;"),
                                attrs: {
                                  rows: _vm.price.remarks ? "5" : "2",
                                  no: "remarks",
                                  readonly: ""
                                },
                                domProps: { value: _vm.price.remarks }
                              })
                            ]),
                            _c("div", { staticClass: "info" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_FreeUseContainer")
                                  )
                                )
                              ]),
                              _c("span", { staticClass: "blue" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.PriceUtils.dataGridColumnclnTimeFunc(
                                      _vm.price.freeTime
                                    )
                                  )
                                )
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("Pricing.priceNature")))
                              ]),
                              _c("span", { staticClass: "blue" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.ColumnUtils.showTypeLabelFunc(
                                      _vm.price.priceNature,
                                      _vm.PriceConstant.PRICE_NATURE
                                    )
                                  )
                                )
                              ])
                            ])
                          ])
                        : _c("div", [
                            _c("div", { staticClass: "info" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("Pricing.DepartureDay")))
                              ]),
                              _c("span", { staticClass: "blue" }, [
                                _vm._v(_vm._s(_vm.isFrequency))
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("Pricing.ClosingDay")))
                              ]),
                              _c("span", { staticClass: "blue" }, [
                                _vm._v(_vm._s(_vm.price.closingDay))
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("Pricing.Days")))
                              ]),
                              _c("span", { staticClass: "blue" }, [
                                _vm._v(_vm._s(_vm.price.days))
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("Pricing.Via")))
                              ]),
                              _c("span", { staticClass: "blue" }, [
                                _vm._v(_vm._s(_vm.getPortName(_vm.price.via)))
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("Pricing.VAT")))
                              ]),
                              _c("span", { staticClass: "blue" }, [
                                _vm._v(
                                  _vm._s(
                                    (_vm.level === 0
                                      ? _vm.price.costVat
                                      : _vm.price.sellVat) + "%"
                                  )
                                )
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("Pricing.PaymentTerm")))
                              ]),
                              _c("span", { staticClass: "blue" }, [
                                _vm._v(
                                  _vm._s(_vm.paymentLabelFunc(_vm.price.term))
                                )
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("Pricing.CabinNature")))
                              ]),
                              _c("span", { staticClass: "blue" }, [
                                _vm._v(
                                  _vm._s(_vm.getShareLabel(_vm.price.share))
                                )
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("Pricing.BeginDate")))
                              ]),
                              _c("span", { staticClass: "blue" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm
                                      .$moment(_vm.price.beginDate)
                                      .format("YYYY-MM-DD") +
                                      " - " +
                                      _vm
                                        .$moment(_vm.price.endDate)
                                        .format("YYYY-MM-DD")
                                  )
                                )
                              ])
                            ]),
                            _c("div", { staticClass: "info" }, [
                              _c("span", { staticStyle: { float: "left" } }, [
                                _vm._v(_vm._s(_vm.$t("Pricing.Remarks")))
                              ]),
                              _c("textarea", {
                                staticClass: "blueRemark",
                                style:
                                  "width:90%; overflow-y: visible;" +
                                  (_vm.price.remarks
                                    ? "border-width: 1px;border-color: #ccc;"
                                    : "border: none;resize: none;"),
                                attrs: {
                                  rows: _vm.price.remarks ? "5" : "2",
                                  no: "remarks2",
                                  readonly: ""
                                },
                                domProps: { value: _vm.price.remarks }
                              })
                            ]),
                            _c("div", { staticClass: "info" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("Pricing.priceNature")))
                              ]),
                              _c("span", { staticClass: "blue" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.ColumnUtils.showTypeLabelFunc(
                                      _vm.price.priceNature,
                                      _vm.PriceConstant.PRICE_NATURE
                                    )
                                  )
                                )
                              ])
                            ])
                          ])
                    ]
                  ],
                  2
                ),
                [
                  _vm.isFcl
                    ? _c("surcharge-fcl-data-grid", {
                        attrs: {
                          "config-module": "22010101",
                          "row-data": _vm.surchargeFCLData,
                          "show-approve": false,
                          "show-cost": _vm.showCost,
                          "price-no": _vm.price.priceNo,
                          "show-selection": false,
                          "show-cost-or-sell": true,
                          "show-basic-info": false,
                          "show-remark": false,
                          filter: _vm.filter,
                          "file-name": "SurchargeFcl",
                          "grid-options": _vm.surchargeFCLDataGrid.gridOptions
                        }
                      })
                    : _c("pol-charge-data-grid", {
                        attrs: {
                          "config-module": "22010102",
                          "show-selection": false,
                          "show-basic-info": false,
                          "show-cost-or-sell": true,
                          "show-cost": true,
                          "row-data": _vm.PODChargeData,
                          "grid-options": _vm.PODChargeDataGrid.gridOptions
                        }
                      })
                ],
                _c("p", [_vm._v(_vm._s(_vm.$t("Pricing.WeightLimitInfo")))]),
                _c("weight-limit-data-grid", {
                  attrs: {
                    "config-module": "22010103",
                    "row-data": _vm.priceWeightLimitData,
                    "grid-options": _vm.priceWeightLimitDataGrid.gridOptions
                  }
                }),
                _c("p", [_vm._v(_vm._s(_vm.$t("Pricing.ExtraInfo")))]),
                _c("fcl-extra-data-grid", {
                  attrs: {
                    "config-module": "22010104",
                    "show-check-box": false,
                    "show-branch": false,
                    "show-create": false,
                    "show-modify": false,
                    "row-data": _vm.priceFCLExtraData,
                    "grid-options": _vm.priceFCLExtraDataGrid.gridOptions
                  }
                }),
                _vm.isFcl
                  ? [
                      _c("p", [_vm._v(_vm._s(_vm.$t("Pricing.ScheduleInfo")))]),
                      _c("shipping-schedule-data-grid", {
                        attrs: {
                          "show-check-box": false,
                          "config-module": "22010105",
                          "row-data": _vm.shippingScheduleData,
                          "show-approve": false,
                          "show-basic-info": false,
                          "show-branch": false,
                          "show-create": false,
                          "show-modify": false,
                          "grid-options":
                            _vm.shippingScheduleDataGrid.gridOptions
                        }
                      })
                    ]
                  : _vm._e()
              ],
              2
            )
          ]
        : _vm._e(),
      _c("customer-popup", {
        attrs: { visible: _vm.customerPopup.visible },
        on: {
          ok: _vm.doRemoteBooking,
          close: function($event) {
            _vm.customerPopup.visible = false
          }
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }